export const Logo = ({ small }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <img src="/favicon.svg" alt="GREENRGY" className={small ? "h-8 w-8" : "h-10 w-10"} />
    <div className="leading-tight">
      <div className="font-extrabold tracking-tight text-slate-900">GREENRGY</div>
      <div className="text-[10px] font-semibold uppercase tracking-[0.25em] text-emerald-600">CRM</div>
    </div>
  </div>
);
